import { State } from '../type';
import React from 'react';
import styles from '../product-timeline.module.scss';
import { useTranslation } from 'react-i18next';
import { Button, useWindowSize } from '../fake';

const ErrorView: React.FC<{
  state: State;
  updateState: (s: State) => void;
}> = ({ state, updateState }) => {
  const { t } = useTranslation();
  const { isWiderThanMd } = useWindowSize();
  return (
    <div className={styles.ordersSales__mainRight__error}>
      <div className={styles.ordersSales__mainRight__error__text}>{t('MY_ACCOUNT.ORDERS_SALES.ERROR.API')}</div>
      {!isWiderThanMd && (
        <Button
          variant="outline"
          size="medium"
          onClick={() => updateState({ ...state, currentOrder: null, currentProduct: null })}
        >
          {t('MY_ACCOUNT.ORDERS_SALES.BACK')}
        </Button>
      )}
    </div>
  );
};

export default ErrorView;
